import type { AssetData } from "@/types/onboarding";

export const FALLBACK_SRC =
  "https://imagedelivery.net/kAmxXLog4Jpwgl_SuFtw6w/050fee6f-21f6-46c6-5952-5e41b0582900/public";

/**
 * Convert an asset value to a URL string
 * @param value - AssetData object
 * @returns A URL string
 */
export function getAssetUrl(value: AssetData): string {
  if (value?.src && value.src !== "") {
    return value.src;
  }
  return FALLBACK_SRC;
}
